import React from 'react';
import image from '../assets/images/socmed.svg'

function Socmed(){
    return(
        <section id="socmed">
            <div className="socmed-content" data-aos="fade-right">
                <h3>Our Social Media</h3>
                <div className="socmed-email">
                    <i className="fas fa-envelope-open-text"></i>
                    <span>irina.kembanglarangan@gmail.com</span>
                </div>
                <div className="socmed-ig">
                    <i className="fab fa-instagram"></i>
                    <a href="https://instagram.com/irina_nilakandi" target="_blank" rel="noopener noreferrer"><span>@irina_nilakandi</span></a>
                </div>
                <div className="socmed-yt">
                    <i className="fab fa-youtube"></i>
                    <a href="https://bit.ly/YouTubeIRINA" target="_blank" rel="noopener noreferrer"><span>bit.ly/YouTubeIRINA</span></a>
                </div>
            </div>
            <div className="socmed-image" data-aos="fade-left">
                <img src={image} alt="socmed-ill"></img>
            </div>
        </section>
    )
}

export default Socmed